import { useEffect, useRef } from 'react';

export default function useTourIdleHelp(enabled, onHelp, activityKey = null) {
  const used = useRef(false);
  const callback = useRef(onHelp);
  callback.current = onHelp;
  useEffect(() => {
    if (!enabled || used.current) return undefined;
    let timer;
    const schedule = () => {
      clearTimeout(timer);
      if (!document.hidden && !used.current) timer = setTimeout(() => {
        used.current = true;
        callback.current();
      }, 18000);
    };
    schedule();
    document.addEventListener('visibilitychange', schedule);
    return () => { clearTimeout(timer); document.removeEventListener('visibilitychange', schedule); };
  }, [enabled, activityKey]);
}
